import React, { useRef, useEffect, useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import { store as mainStore } from '../../../../../store';
import { store } from './Freights';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '../../../../../components/Accordion/Accordion';
import { isMobile } from 'react-device-detect';
import checkMobilePhone from '../../../../../fns/checkMobilePhone';
import normalizeMobilePhone from '../../../../../fns/normalizeMobile';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    '&>*': {
      marginBottom: theme.spacing(1),
    },
  },
  filters: {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr 1fr' : '1fr 1fr 1fr 1fr 1fr',
    gridGap: theme.spacing(1),
  },
}));

const FreightsSearchBox = () => {
  const firstTime = useRef(true);
  const classes = useStyles();

  const {
    state: {
      Props: { itemsCountPerPage },
    },
    showMessage,
    showError,
  } = useContext(mainStore);
  const {
    state,
    dispatch,
    actions: { fetchingFreights },
  } = useContext(store);
  const { search, users, page, isLoaded } = state;
  const { firstName, lastName, nationalCode, mobilePhone, company } = search;

  const handleChange = (e) => {
    let { name, value } = e.target;
    name === 'mobilePhone' && (value = checkMobilePhone(value) || value);
    dispatch({ type: 'CHANGE_FIELDS', payload: { name, value } });
  };

  useEffect(() => {
    if (firstTime.current) {
      firstTime.current = false;
      return;
    }
    (async () => {
      try {
        dispatch({ type: 'LOADING' });
        const c = await fetchingFreights(page, itemsCountPerPage, search);
        dispatch({ type: 'FREIGHTS', payload: c });
      } catch (error) {
        showError(error);
      }
    })();
  }, [firstName, lastName, nationalCode, mobilePhone, company]);

  return (
    <div className={classes.root}>
      <Accordion title="فیلترهای جستجو">
        <div className={classes.filters}>
          <TextField
            name="firstName"
            value={firstName ? firstName : ''}
            onChange={handleChange}
            variant="outlined"
            label="نام"
            size="small"
            fullWidth
          />
          <TextField
            name="lastName"
            value={lastName ? lastName : ''}
            onChange={handleChange}
            variant="outlined"
            label="نام خانوادگی"
            size="small"
            fullWidth
          />
          <TextField
            name="nationalCode"
            value={nationalCode ? nationalCode : ''}
            onChange={handleChange}
            variant="outlined"
            label="کدملی"
            size="small"
            fullWidth
          />
          <TextField
            name="company"
            value={company || ''}
            onChange={handleChange}
            variant="outlined"
            label="نام شرکت"
            size="small"
            fullWidth
          />
          <TextField
            name="mobilePhone"
            value={mobilePhone ? normalizeMobilePhone(mobilePhone) : ''}
            onChange={handleChange}
            variant="outlined"
            label="موبایل"
            size="small"
            fullWidth
          />
        </div>
      </Accordion>
    </div>
  );
};

export default React.memo(FreightsSearchBox);
